
namespace RioERP.Masters {
    export class LevelsColumns {
        static columnsKey = 'Masters.Levels';
    }
}